import React from "react";
import { boothVideo1 } from "../assets";
import Button from "./common/Button";

const Booth = () => {
  return (
    <>
      <header className="hidden sm:flex relative items-center justify-center h-screen overflow-hidden">
        <video autoPlay loop muted className="absolute">
          <source src={boothVideo1} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="flex text-center items-center flex-col z-30 w-full">
          <div className="flex flex-col justify-center px-4 w-[300px]">
            <div
              data-aos="fade-left"
              data-aos-duration="1200"
              className="font-medium absolute right-[16px] lg:w-[500px] rounded backdrop-blur-sm p-4 text-white text-left"
            >
              <div>

              <div className="text-white text-2xl md:text-3xl font-gunterz lg:text-[26px] font-extrabold">
                THIS PHOTOBOOTH
              </div>
              <div className="custom-gradient-2 text-xl lg:text-[32px] md:text-2xl font-gunterz font-extrabold tracking-[-2] mb-1 lg:mb-5">
                MIXED REALLITY
              </div>
              </div>
              <div className=" mb-10 text-white font-poppins w-[340px]">
                Step into a new world with LightXR - Mixed Reality Photobooth.
                Cutting Edge Visual AI Technology that turns light into a
                paintbrush and the world around, your canvas. With LightXR we
                have the power to seamlessly blend real and virtual worlds. Make
                unique videos and images for your next social media interaction
                and send them with our Integrated Sharing Station.{" "}
              </div>
              <Button style="lg:text-xl" name="3D view" />
            </div>
          </div>
        </div>
        <div className="centered"></div>
      </header>

      {/* for Phone */}

      <div
        data-aos="fade-right"
        data-aos-duration="1200"
        className="flex sm:hidden flex-col py-10 px-8 justify-center"
      >
        <div className="flex flex-col">
          <div className="text-white font-gunterz text-[30px] font-extrabold">
            PHOTOBOOTH
          </div>
          <div className="custom-gradient-2 font-gunterz text-2xl tracking-[2px] mb-1">
            MIXED REALLITY
          </div>
        </div>
        <div className="relative flex flex-col my-10 md:w-[600px]">
          <div className="absolute rounded-[22px] parent z-20 overflow-hidden">
            <video
              autoPlay
              loop
              muted
              className="rounded-[22px] min-w-[330px] max-h-[250px]"
            >
              <source src={boothVideo1} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div className="relative child transition-all duration-300 min-w-[330px] min-h-[190px] bg-gradient-to-bl from-sky-500 to-green-500 rounded-[22px]" />
        </div>
        <div>
          <div className="lg:w-96 sm:w-64 mb-10 text-white text-sm md:text-[16px] font-poppins lg:text-xl lg:leading-7">
            Step into a new world with LightXR - Mixed Reality Photobooth.
            Cutting Edge Visual AI Technology that turns light into a paintbrush
            and the world around, your canvas. With LightXR we have the power to
            seamlessly blend real and virtual worlds. Make unique videos and
            images for your next social media interaction and send them with our
            Integrated Sharing Station.{" "}
          </div>
          <Button name="3D view" />
        </div>
      </div>
    </>
  );
};

export default Booth;
